<template>
  <FAQView />
</template>

<script>
import FAQView from '@/components/views/FAQView/FAQView.vue';
import pageCommonMixin from '@/components/mixins/pageCommonMixin';
import AppConstantsUtil from '@/services/utils/AppConstantsUtil';
export default {
  name: 'FAQPage',
  components: {
    FAQView
  },
  mixins: [pageCommonMixin],
  data() {
    return {};
  },
  head() {
    const headSettings = this.getCommonHeadSettings();
    const bodyAttrs = headSettings.bodyAttrs;
    const commonClasses = this.getCommonPageClasses();
    const classes = [...commonClasses];
    const link = [];
    if (this.canonicalLinkSetting) {
      link.push(this.canonicalLinkSetting);
    }
    return {
      ...headSettings,
      link,
      htmlAttrs: {
        class: [
          ...this.htmlClassList,
          AppConstantsUtil.MANAGE_PUBLICATION_SCROLL_CLASS
        ]
      },
      bodyAttrs: {
        ...bodyAttrs,
        class: classes
      }
    };
  }
};
</script>
